import { Navbar, Footer } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function CreateProviderProfile() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    business_name: "",
    business_type: "hobby",
    description: "",
    service_area: "",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;
    setLoading(true);
    const { error } = await supabase.from("provider_profiles").insert({
      user_id: user.id,
      business_name: form.business_name,
      business_type: form.business_type,
      description: form.description,
      service_area: form.service_area,
    });
    setLoading(false);
    if (error) {
      toast.error("Kunde inte skapa profil: " + error.message);
    } else {
      toast.success("Leverantörsprofil skapad!");
      navigate("/dashboard");
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container max-w-lg flex-1 py-8">
        <h1 className="mb-6 font-display text-2xl font-bold">Skapa leverantörsprofil</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Företagsnamn / Namn</Label>
            <Input value={form.business_name} onChange={(e) => setForm(p => ({ ...p, business_name: e.target.value }))} required />
          </div>
          <div>
            <Label>Typ</Label>
            <Select value={form.business_type} onValueChange={(v) => setForm(p => ({ ...p, business_type: v }))}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="hobby">Hobbyaktör</SelectItem>
                <SelectItem value="företag">Företag</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Beskrivning</Label>
            <Textarea value={form.description} onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))} rows={3} />
          </div>
          <div>
            <Label>Tjänsteområde</Label>
            <Input value={form.service_area} onChange={(e) => setForm(p => ({ ...p, service_area: e.target.value }))} placeholder="T.ex. Stockholm, 50 km radie" />
          </div>
          <Button className="w-full" type="submit" disabled={loading}>
            {loading ? "Skapar…" : "Skapa profil"}
          </Button>
        </form>
      </div>
      <Footer hideOnMobile />
    </div>
  );
}
